// extracted by css-extract-rspack-plugin
export default {"ButtonGroup":"PaneHeader-module__ButtonGroup___tIYmL"};